import { render, staticRenderFns } from "./directional_order.vue?vue&type=template&id=a230d0d0&scoped=true&"
import script from "./directional_order.vue?vue&type=script&lang=js&"
export * from "./directional_order.vue?vue&type=script&lang=js&"
import style0 from "./directional_order.vue?vue&type=style&index=0&id=a230d0d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a230d0d0",
  null
  
)

export default component.exports